export interface CountryDialCode {
  label: string;
  value: string; // ISO-2 code — unique across entries
  dialCode: string;
  flag: string;
}

export const COUNTRY_DIAL_CODES: CountryDialCode[] = [
  // A
  { value: 'AF', flag: '🇦🇫', dialCode: '+93',  label: '🇦🇫 +93  Afghanistan' },
  { value: 'AL', flag: '🇦🇱', dialCode: '+355', label: '🇦🇱 +355 Albania' },
  { value: 'DZ', flag: '🇩🇿', dialCode: '+213', label: '🇩🇿 +213 Algeria' },
  { value: 'AD', flag: '🇦🇩', dialCode: '+376', label: '🇦🇩 +376 Andorra' },
  { value: 'AO', flag: '🇦🇴', dialCode: '+244', label: '🇦🇴 +244 Angola' },
  { value: 'AG', flag: '🇦🇬', dialCode: '+1',   label: '🇦🇬 +1   Antigua & Barbuda' },
  { value: 'AR', flag: '🇦🇷', dialCode: '+54',  label: '🇦🇷 +54  Argentina' },
  { value: 'AM', flag: '🇦🇲', dialCode: '+374', label: '🇦🇲 +374 Armenia' },
  { value: 'AU', flag: '🇦🇺', dialCode: '+61',  label: '🇦🇺 +61  Australia' },
  { value: 'AT', flag: '🇦🇹', dialCode: '+43',  label: '🇦🇹 +43  Austria' },
  { value: 'AZ', flag: '🇦🇿', dialCode: '+994', label: '🇦🇿 +994 Azerbaijan' },
  // B
  { value: 'BS', flag: '🇧🇸', dialCode: '+1',   label: '🇧🇸 +1   Bahamas' },
  { value: 'BH', flag: '🇧🇭', dialCode: '+973', label: '🇧🇭 +973 Bahrain' },
  { value: 'BD', flag: '🇧🇩', dialCode: '+880', label: '🇧🇩 +880 Bangladesh' },
  { value: 'BB', flag: '🇧🇧', dialCode: '+1',   label: '🇧🇧 +1   Barbados' },
  { value: 'BY', flag: '🇧🇾', dialCode: '+375', label: '🇧🇾 +375 Belarus' },
  { value: 'BE', flag: '🇧🇪', dialCode: '+32',  label: '🇧🇪 +32  Belgium' },
  { value: 'BZ', flag: '🇧🇿', dialCode: '+501', label: '🇧🇿 +501 Belize' },
  { value: 'BJ', flag: '🇧🇯', dialCode: '+229', label: '🇧🇯 +229 Benin' },
  { value: 'BT', flag: '🇧🇹', dialCode: '+975', label: '🇧🇹 +975 Bhutan' },
  { value: 'BO', flag: '🇧🇴', dialCode: '+591', label: '🇧🇴 +591 Bolivia' },
  { value: 'BA', flag: '🇧🇦', dialCode: '+387', label: '🇧🇦 +387 Bosnia & Herzegovina' },
  { value: 'BW', flag: '🇧🇼', dialCode: '+267', label: '🇧🇼 +267 Botswana' },
  { value: 'BR', flag: '🇧🇷', dialCode: '+55',  label: '🇧🇷 +55  Brazil' },
  { value: 'BN', flag: '🇧🇳', dialCode: '+673', label: '🇧🇳 +673 Brunei' },
  { value: 'BG', flag: '🇧🇬', dialCode: '+359', label: '🇧🇬 +359 Bulgaria' },
  { value: 'BF', flag: '🇧🇫', dialCode: '+226', label: '🇧🇫 +226 Burkina Faso' },
  { value: 'BI', flag: '🇧🇮', dialCode: '+257', label: '🇧🇮 +257 Burundi' },
  // C
  { value: 'CV', flag: '🇨🇻', dialCode: '+238', label: '🇨🇻 +238 Cape Verde' },
  { value: 'KH', flag: '🇰🇭', dialCode: '+855', label: '🇰🇭 +855 Cambodia' },
  { value: 'CM', flag: '🇨🇲', dialCode: '+237', label: '🇨🇲 +237 Cameroon' },
  { value: 'CA', flag: '🇨🇦', dialCode: '+1',   label: '🇨🇦 +1   Canada' },
  { value: 'CF', flag: '🇨🇫', dialCode: '+236', label: '🇨🇫 +236 Central African Republic' },
  { value: 'TD', flag: '🇹🇩', dialCode: '+235', label: '🇹🇩 +235 Chad' },
  { value: 'CL', flag: '🇨🇱', dialCode: '+56',  label: '🇨🇱 +56  Chile' },
  { value: 'CN', flag: '🇨🇳', dialCode: '+86',  label: '🇨🇳 +86  China' },
  { value: 'CO', flag: '🇨🇴', dialCode: '+57',  label: '🇨🇴 +57  Colombia' },
  { value: 'KM', flag: '🇰🇲', dialCode: '+269', label: '🇰🇲 +269 Comoros' },
  { value: 'CG', flag: '🇨🇬', dialCode: '+242', label: '🇨🇬 +242 Congo' },
  { value: 'CD', flag: '🇨🇩', dialCode: '+243', label: '🇨🇩 +243 Congo (DRC)' },
  { value: 'CR', flag: '🇨🇷', dialCode: '+506', label: '🇨🇷 +506 Costa Rica' },
  { value: 'HR', flag: '🇭🇷', dialCode: '+385', label: '🇭🇷 +385 Croatia' },
  { value: 'CU', flag: '🇨🇺', dialCode: '+53',  label: '🇨🇺 +53  Cuba' },
  { value: 'CY', flag: '🇨🇾', dialCode: '+357', label: '🇨🇾 +357 Cyprus' },
  { value: 'CZ', flag: '🇨🇿', dialCode: '+420', label: '🇨🇿 +420 Czech Republic' },
  { value: 'CI', flag: '🇨🇮', dialCode: '+225', label: '🇨🇮 +225 Côte d\'Ivoire' },
  // D
  { value: 'DK', flag: '🇩🇰', dialCode: '+45',  label: '🇩🇰 +45  Denmark' },
  { value: 'DJ', flag: '🇩🇯', dialCode: '+253', label: '🇩🇯 +253 Djibouti' },
  { value: 'DM', flag: '🇩🇲', dialCode: '+1',   label: '🇩🇲 +1   Dominica' },
  { value: 'DO', flag: '🇩🇴', dialCode: '+1',   label: '🇩🇴 +1   Dominican Republic' },
  // E
  { value: 'EC', flag: '🇪🇨', dialCode: '+593', label: '🇪🇨 +593 Ecuador' },
  { value: 'EG', flag: '🇪🇬', dialCode: '+20',  label: '🇪🇬 +20  Egypt' },
  { value: 'SV', flag: '🇸🇻', dialCode: '+503', label: '🇸🇻 +503 El Salvador' },
  { value: 'GQ', flag: '🇬🇶', dialCode: '+240', label: '🇬🇶 +240 Equatorial Guinea' },
  { value: 'ER', flag: '🇪🇷', dialCode: '+291', label: '🇪🇷 +291 Eritrea' },
  { value: 'EE', flag: '🇪🇪', dialCode: '+372', label: '🇪🇪 +372 Estonia' },
  { value: 'SZ', flag: '🇸🇿', dialCode: '+268', label: '🇸🇿 +268 Eswatini' },
  { value: 'ET', flag: '🇪🇹', dialCode: '+251', label: '🇪🇹 +251 Ethiopia' },
  // F
  { value: 'FJ', flag: '🇫🇯', dialCode: '+679', label: '🇫🇯 +679 Fiji' },
  { value: 'FI', flag: '🇫🇮', dialCode: '+358', label: '🇫🇮 +358 Finland' },
  { value: 'FR', flag: '🇫🇷', dialCode: '+33',  label: '🇫🇷 +33  France' },
  // G
  { value: 'GA', flag: '🇬🇦', dialCode: '+241', label: '🇬🇦 +241 Gabon' },
  { value: 'GM', flag: '🇬🇲', dialCode: '+220', label: '🇬🇲 +220 Gambia' },
  { value: 'GE', flag: '🇬🇪', dialCode: '+995', label: '🇬🇪 +995 Georgia' },
  { value: 'DE', flag: '🇩🇪', dialCode: '+49',  label: '🇩🇪 +49  Germany' },
  { value: 'GH', flag: '🇬🇭', dialCode: '+233', label: '🇬🇭 +233 Ghana' },
  { value: 'GR', flag: '🇬🇷', dialCode: '+30',  label: '🇬🇷 +30  Greece' },
  { value: 'GD', flag: '🇬🇩', dialCode: '+1',   label: '🇬🇩 +1   Grenada' },
  { value: 'GT', flag: '🇬🇹', dialCode: '+502', label: '🇬🇹 +502 Guatemala' },
  { value: 'GN', flag: '🇬🇳', dialCode: '+224', label: '🇬🇳 +224 Guinea' },
  { value: 'GW', flag: '🇬🇼', dialCode: '+245', label: '🇬🇼 +245 Guinea-Bissau' },
  { value: 'GY', flag: '🇬🇾', dialCode: '+592', label: '🇬🇾 +592 Guyana' },
  // H
  { value: 'HT', flag: '🇭🇹', dialCode: '+509', label: '🇭🇹 +509 Haiti' },
  { value: 'HN', flag: '🇭🇳', dialCode: '+504', label: '🇭🇳 +504 Honduras' },
  { value: 'HU', flag: '🇭🇺', dialCode: '+36',  label: '🇭🇺 +36  Hungary' },
  // I
  { value: 'IS', flag: '🇮🇸', dialCode: '+354', label: '🇮🇸 +354 Iceland' },
  { value: 'IN', flag: '🇮🇳', dialCode: '+91',  label: '🇮🇳 +91  India' },
  { value: 'ID', flag: '🇮🇩', dialCode: '+62',  label: '🇮🇩 +62  Indonesia' },
  { value: 'IR', flag: '🇮🇷', dialCode: '+98',  label: '🇮🇷 +98  Iran' },
  { value: 'IQ', flag: '🇮🇶', dialCode: '+964', label: '🇮🇶 +964 Iraq' },
  { value: 'IE', flag: '🇮🇪', dialCode: '+353', label: '🇮🇪 +353 Ireland' },
  { value: 'IL', flag: '🇮🇱', dialCode: '+972', label: '🇮🇱 +972 Israel' },
  { value: 'IT', flag: '🇮🇹', dialCode: '+39',  label: '🇮🇹 +39  Italy' },
  // J
  { value: 'JM', flag: '🇯🇲', dialCode: '+1',   label: '🇯🇲 +1   Jamaica' },
  { value: 'JP', flag: '🇯🇵', dialCode: '+81',  label: '🇯🇵 +81  Japan' },
  { value: 'JO', flag: '🇯🇴', dialCode: '+962', label: '🇯🇴 +962 Jordan' },
  // K
  { value: 'KZ', flag: '🇰🇿', dialCode: '+7',   label: '🇰🇿 +7   Kazakhstan' },
  { value: 'KE', flag: '🇰🇪', dialCode: '+254', label: '🇰🇪 +254 Kenya' },
  { value: 'KI', flag: '🇰🇮', dialCode: '+686', label: '🇰🇮 +686 Kiribati' },
  { value: 'XK', flag: '🇽🇰', dialCode: '+383', label: '🇽🇰 +383 Kosovo' },
  { value: 'KW', flag: '🇰🇼', dialCode: '+965', label: '🇰🇼 +965 Kuwait' },
  { value: 'KG', flag: '🇰🇬', dialCode: '+996', label: '🇰🇬 +996 Kyrgyzstan' },
  // L
  { value: 'LA', flag: '🇱🇦', dialCode: '+856', label: '🇱🇦 +856 Laos' },
  { value: 'LV', flag: '🇱🇻', dialCode: '+371', label: '🇱🇻 +371 Latvia' },
  { value: 'LB', flag: '🇱🇧', dialCode: '+961', label: '🇱🇧 +961 Lebanon' },
  { value: 'LS', flag: '🇱🇸', dialCode: '+266', label: '🇱🇸 +266 Lesotho' },
  { value: 'LR', flag: '🇱🇷', dialCode: '+231', label: '🇱🇷 +231 Liberia' },
  { value: 'LY', flag: '🇱🇾', dialCode: '+218', label: '🇱🇾 +218 Libya' },
  { value: 'LI', flag: '🇱🇮', dialCode: '+423', label: '🇱🇮 +423 Liechtenstein' },
  { value: 'LT', flag: '🇱🇹', dialCode: '+370', label: '🇱🇹 +370 Lithuania' },
  { value: 'LU', flag: '🇱🇺', dialCode: '+352', label: '🇱🇺 +352 Luxembourg' },
  // M
  { value: 'MG', flag: '🇲🇬', dialCode: '+261', label: '🇲🇬 +261 Madagascar' },
  { value: 'MW', flag: '🇲🇼', dialCode: '+265', label: '🇲🇼 +265 Malawi' },
  { value: 'MY', flag: '🇲🇾', dialCode: '+60',  label: '🇲🇾 +60  Malaysia' },
  { value: 'MV', flag: '🇲🇻', dialCode: '+960', label: '🇲🇻 +960 Maldives' },
  { value: 'ML', flag: '🇲🇱', dialCode: '+223', label: '🇲🇱 +223 Mali' },
  { value: 'MT', flag: '🇲🇹', dialCode: '+356', label: '🇲🇹 +356 Malta' },
  { value: 'MH', flag: '🇲🇭', dialCode: '+692', label: '🇲🇭 +692 Marshall Islands' },
  { value: 'MR', flag: '🇲🇷', dialCode: '+222', label: '🇲🇷 +222 Mauritania' },
  { value: 'MU', flag: '🇲🇺', dialCode: '+230', label: '🇲🇺 +230 Mauritius' },
  { value: 'MX', flag: '🇲🇽', dialCode: '+52',  label: '🇲🇽 +52  Mexico' },
  { value: 'FM', flag: '🇫🇲', dialCode: '+691', label: '🇫🇲 +691 Micronesia' },
  { value: 'MD', flag: '🇲🇩', dialCode: '+373', label: '🇲🇩 +373 Moldova' },
  { value: 'MC', flag: '🇲🇨', dialCode: '+377', label: '🇲🇨 +377 Monaco' },
  { value: 'MN', flag: '🇲🇳', dialCode: '+976', label: '🇲🇳 +976 Mongolia' },
  { value: 'ME', flag: '🇲🇪', dialCode: '+382', label: '🇲🇪 +382 Montenegro' },
  { value: 'MA', flag: '🇲🇦', dialCode: '+212', label: '🇲🇦 +212 Morocco' },
  { value: 'MZ', flag: '🇲🇿', dialCode: '+258', label: '🇲🇿 +258 Mozambique' },
  { value: 'MM', flag: '🇲🇲', dialCode: '+95',  label: '🇲🇲 +95  Myanmar' },
  // N
  { value: 'NA', flag: '🇳🇦', dialCode: '+264', label: '🇳🇦 +264 Namibia' },
  { value: 'NR', flag: '🇳🇷', dialCode: '+674', label: '🇳🇷 +674 Nauru' },
  { value: 'NP', flag: '🇳🇵', dialCode: '+977', label: '🇳🇵 +977 Nepal' },
  { value: 'NL', flag: '🇳🇱', dialCode: '+31',  label: '🇳🇱 +31  Netherlands' },
  { value: 'NZ', flag: '🇳🇿', dialCode: '+64',  label: '🇳🇿 +64  New Zealand' },
  { value: 'NI', flag: '🇳🇮', dialCode: '+505', label: '🇳🇮 +505 Nicaragua' },
  { value: 'NE', flag: '🇳🇪', dialCode: '+227', label: '🇳🇪 +227 Niger' },
  { value: 'NG', flag: '🇳🇬', dialCode: '+234', label: '🇳🇬 +234 Nigeria' },
  { value: 'KP', flag: '🇰🇵', dialCode: '+850', label: '🇰🇵 +850 North Korea' },
  { value: 'MK', flag: '🇲🇰', dialCode: '+389', label: '🇲🇰 +389 North Macedonia' },
  { value: 'NO', flag: '🇳🇴', dialCode: '+47',  label: '🇳🇴 +47  Norway' },
  // O
  { value: 'OM', flag: '🇴🇲', dialCode: '+968', label: '🇴🇲 +968 Oman' },
  // P
  { value: 'PK', flag: '🇵🇰', dialCode: '+92',  label: '🇵🇰 +92  Pakistan' },
  { value: 'PW', flag: '🇵🇼', dialCode: '+680', label: '🇵🇼 +680 Palau' },
  { value: 'PS', flag: '🇵🇸', dialCode: '+970', label: '🇵🇸 +970 Palestine' },
  { value: 'PA', flag: '🇵🇦', dialCode: '+507', label: '🇵🇦 +507 Panama' },
  { value: 'PG', flag: '🇵🇬', dialCode: '+675', label: '🇵🇬 +675 Papua New Guinea' },
  { value: 'PY', flag: '🇵🇾', dialCode: '+595', label: '🇵🇾 +595 Paraguay' },
  { value: 'PE', flag: '🇵🇪', dialCode: '+51',  label: '🇵🇪 +51  Peru' },
  { value: 'PH', flag: '🇵🇭', dialCode: '+63',  label: '🇵🇭 +63  Philippines' },
  { value: 'PL', flag: '🇵🇱', dialCode: '+48',  label: '🇵🇱 +48  Poland' },
  { value: 'PT', flag: '🇵🇹', dialCode: '+351', label: '🇵🇹 +351 Portugal' },
  // Q
  { value: 'QA', flag: '🇶🇦', dialCode: '+974', label: '🇶🇦 +974 Qatar' },
  // R
  { value: 'RO', flag: '🇷🇴', dialCode: '+40',  label: '🇷🇴 +40  Romania' },
  { value: 'RU', flag: '🇷🇺', dialCode: '+7',   label: '🇷🇺 +7   Russia' },
  { value: 'RW', flag: '🇷🇼', dialCode: '+250', label: '🇷🇼 +250 Rwanda' },
  // S
  { value: 'KN', flag: '🇰🇳', dialCode: '+1',   label: '🇰🇳 +1   Saint Kitts & Nevis' },
  { value: 'LC', flag: '🇱🇨', dialCode: '+1',   label: '🇱🇨 +1   Saint Lucia' },
  { value: 'VC', flag: '🇻🇨', dialCode: '+1',   label: '🇻🇨 +1   Saint Vincent & Grenadines' },
  { value: 'WS', flag: '🇼🇸', dialCode: '+685', label: '🇼🇸 +685 Samoa' },
  { value: 'SM', flag: '🇸🇲', dialCode: '+378', label: '🇸🇲 +378 San Marino' },
  { value: 'ST', flag: '🇸🇹', dialCode: '+239', label: '🇸🇹 +239 Sao Tome & Principe' },
  { value: 'SA', flag: '🇸🇦', dialCode: '+966', label: '🇸🇦 +966 Saudi Arabia' },
  { value: 'SN', flag: '🇸🇳', dialCode: '+221', label: '🇸🇳 +221 Senegal' },
  { value: 'RS', flag: '🇷🇸', dialCode: '+381', label: '🇷🇸 +381 Serbia' },
  { value: 'SC', flag: '🇸🇨', dialCode: '+248', label: '🇸🇨 +248 Seychelles' },
  { value: 'SL', flag: '🇸🇱', dialCode: '+232', label: '🇸🇱 +232 Sierra Leone' },
  { value: 'SG', flag: '🇸🇬', dialCode: '+65',  label: '🇸🇬 +65  Singapore' },
  { value: 'SK', flag: '🇸🇰', dialCode: '+421', label: '🇸🇰 +421 Slovakia' },
  { value: 'SI', flag: '🇸🇮', dialCode: '+386', label: '🇸🇮 +386 Slovenia' },
  { value: 'SB', flag: '🇸🇧', dialCode: '+677', label: '🇸🇧 +677 Solomon Islands' },
  { value: 'SO', flag: '🇸🇴', dialCode: '+252', label: '🇸🇴 +252 Somalia' },
  { value: 'ZA', flag: '🇿🇦', dialCode: '+27',  label: '🇿🇦 +27  South Africa' },
  { value: 'KR', flag: '🇰🇷', dialCode: '+82',  label: '🇰🇷 +82  South Korea' },
  { value: 'SS', flag: '🇸🇸', dialCode: '+211', label: '🇸🇸 +211 South Sudan' },
  { value: 'ES', flag: '🇪🇸', dialCode: '+34',  label: '🇪🇸 +34  Spain' },
  { value: 'LK', flag: '🇱🇰', dialCode: '+94',  label: '🇱🇰 +94  Sri Lanka' },
  { value: 'SD', flag: '🇸🇩', dialCode: '+249', label: '🇸🇩 +249 Sudan' },
  { value: 'SR', flag: '🇸🇷', dialCode: '+597', label: '🇸🇷 +597 Suriname' },
  { value: 'SE', flag: '🇸🇪', dialCode: '+46',  label: '🇸🇪 +46  Sweden' },
  { value: 'CH', flag: '🇨🇭', dialCode: '+41',  label: '🇨🇭 +41  Switzerland' },
  { value: 'SY', flag: '🇸🇾', dialCode: '+963', label: '🇸🇾 +963 Syria' },
  // T
  { value: 'TW', flag: '🇹🇼', dialCode: '+886', label: '🇹🇼 +886 Taiwan' },
  { value: 'TJ', flag: '🇹🇯', dialCode: '+992', label: '🇹🇯 +992 Tajikistan' },
  { value: 'TZ', flag: '🇹🇿', dialCode: '+255', label: '🇹🇿 +255 Tanzania' },
  { value: 'TH', flag: '🇹🇭', dialCode: '+66',  label: '🇹🇭 +66  Thailand' },
  { value: 'TL', flag: '🇹🇱', dialCode: '+670', label: '🇹🇱 +670 Timor-Leste' },
  { value: 'TG', flag: '🇹🇬', dialCode: '+228', label: '🇹🇬 +228 Togo' },
  { value: 'TO', flag: '🇹🇴', dialCode: '+676', label: '🇹🇴 +676 Tonga' },
  { value: 'TT', flag: '🇹🇹', dialCode: '+1',   label: '🇹🇹 +1   Trinidad & Tobago' },
  { value: 'TN', flag: '🇹🇳', dialCode: '+216', label: '🇹🇳 +216 Tunisia' },
  { value: 'TR', flag: '🇹🇷', dialCode: '+90',  label: '🇹🇷 +90  Turkey' },
  { value: 'TM', flag: '🇹🇲', dialCode: '+993', label: '🇹🇲 +993 Turkmenistan' },
  { value: 'TV', flag: '🇹🇻', dialCode: '+688', label: '🇹🇻 +688 Tuvalu' },
  // U
  { value: 'UG', flag: '🇺🇬', dialCode: '+256', label: '🇺🇬 +256 Uganda' },
  { value: 'UA', flag: '🇺🇦', dialCode: '+380', label: '🇺🇦 +380 Ukraine' },
  { value: 'AE', flag: '🇦🇪', dialCode: '+971', label: '🇦🇪 +971 UAE' },
  { value: 'GB', flag: '🇬🇧', dialCode: '+44',  label: '🇬🇧 +44  United Kingdom' },
  { value: 'US', flag: '🇺🇸', dialCode: '+1',   label: '🇺🇸 +1   United States' },
  { value: 'UY', flag: '🇺🇾', dialCode: '+598', label: '🇺🇾 +598 Uruguay' },
  { value: 'UZ', flag: '🇺🇿', dialCode: '+998', label: '🇺🇿 +998 Uzbekistan' },
  // V
  { value: 'VU', flag: '🇻🇺', dialCode: '+678', label: '🇻🇺 +678 Vanuatu' },
  { value: 'VA', flag: '🇻🇦', dialCode: '+379', label: '🇻🇦 +379 Vatican City' },
  { value: 'VE', flag: '🇻🇪', dialCode: '+58',  label: '🇻🇪 +58  Venezuela' },
  { value: 'VN', flag: '🇻🇳', dialCode: '+84',  label: '🇻🇳 +84  Vietnam' },
  // Y
  { value: 'YE', flag: '🇾🇪', dialCode: '+967', label: '🇾🇪 +967 Yemen' },
  // Z
  { value: 'ZM', flag: '🇿🇲', dialCode: '+260', label: '🇿🇲 +260 Zambia' },
  { value: 'ZW', flag: '🇿🇼', dialCode: '+263', label: '🇿🇼 +263 Zimbabwe' },
]
